import {STATES} from 'common/domain/states';
import {MODALS} from 'common/domain/constants';
import {LOANS} from 'loans.module/common/domain/constants.loans';
import LoansModalitiesAssembler from 'loans.module/common/assemblers/loans.modalities.assembler';

const MIN_AMOUNT = 120000;
const FIXED_COEFFICIENT = 0.95;

class LoansDetailController {

  constructor($log,
              $state,
              $stateParams,
              $window,
              $q,
              loansStaticService,
              LoansUserDataService,
              LoansOperationsService,
              mainMenuMobileBehaviourService,
              loadingMobileService) {
    'ngInject';
    this.log = $log;
    this.state = $state;
    this.stateParams = $stateParams;
    this.window = $window;
    this.q = $q;

    this.loansStaticService = loansStaticService;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
    this.loadingMobileService = loadingMobileService;

    this.allowGoBack = this.stateParams.allowGoBack;
    this.loanId = this.stateParams.loanId;
    this.isMobileApp = $window.innerWidth < 1024;

    this.loan = this.loansStaticService.get(this.loanId);
    this.init();
  }

  $onInit() {
    this.basicCharacteristicsOpened = this.stateParams.panel === 'basic-characteristics';

    if (this.isMobileApp) {
      this.mainMenuMobileBehaviourService.clean();
    }

    if (this.showFloatingActionButtons()) {
      this.initFloatingActionButtons();
    }

    this.creditCapacityTypes = [
      LOANS.ID.SOCIAL_HOUSING_LOAN,
      LOANS.ID.AGREEMENT_HOUSING_LOAN
    ];
  }

  init() {
    this.log.info('LoansDetailController init()', this.loansUserDataService._employee.userId);
    this.loadingMobileService.show();

    this.dataTableBasicCharacteristics = this.loansStaticService.getDataTableBasicCharacteristics();
    this.getModalities();

    this.q.all([
      this.loansOperationsService.getCreditworthiness(this.loansUserDataService._employee.userId),
      this.loansOperationsService.getEuribor()
    ]).then(responses => {
      this.creditworthiness = responses[0];
      this.simulationWitness = this.creditworthiness.simulationWitness;
      this.euribor = responses[1].data.euribor;
      this.loaded = true;
    }, error => {
      this.log.error('LoansDetailController init()', error);
      // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
      // this.state.go(STATES.ERROR);
    }).finally(()=> {
      this.loadingMobileService.hide();
    });
  }

  get modal() {
    return $(MODALS.CANNOT_SIGNUP);
  }

  goBack() {
    let {loanId, from, originalFrom, snapshot} = this.stateParams;

    const backupFrom = from;

    const flowStartedAtNeedALoan = !!originalFrom && from !== originalFrom;

    if (flowStartedAtNeedALoan) {
      from = originalFrom;
    }

    this.state.go(backupFrom, {loanId, snapshot, from, originalFrom});
  }

  showFloatingActionButtons() {
    return this.isMobileApp && !this.stateParams.from;
  }

  showNewCreditCapacity() {
    return this.creditCapacityTypes.includes(this.loanId) && this.simulationWitness;
  }

  initFloatingActionButtons() {
    this.floatingActionButtons = [
      {
        literal: 'LOANS.LOANS_DETAIL.SIGN_UP',
      },
    ];
  }

  getCreditworthiness() {
    this.log.info('LoansDetailController init() getCreditworthiness()', this.loansUserDataService._employee.userId);
    this.loadingMobileService.show();

    this.loansOperationsService.getCreditworthiness(this.loansUserDataService._employee.userId).then(creditworthiness => {
      this.creditworthiness = creditworthiness;
      this.loaded = true;
    }, error => {
      this.log.error('LoansDetailController init() getCreditworthiness()', error);
      // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
      // this.state.go(STATES.ERROR);
    }).finally(() => {
      this.loadingMobileService.hide();
    });

  }

  getEuribor() {
    this.log.info('LoansDetailController init() getEuribor()');
    this.loansOperationsService.getEuribor().then(response => {
      this.euribor = response.data.euribor;
    }, error => {
      this.log.error('LoansDetailController init() getEuribor()', error);
      // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
      // this.state.go(STATES.ERROR);
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }

  getModalities() {
    const modalities = this.loansUserDataService.getModalities();
    const loansModalitiesAssembler = new LoansModalitiesAssembler(modalities);
    const allPurposes = loansModalitiesAssembler.assemble();
    this.loanPurposes = allPurposes[this.loanId];
  }

  hasPurposeSubtitle() {
    return this.loanId === LOANS.ID.FIVE_MONTH || this.loanId === LOANS.ID.NINE_MONTH || this.loanId === LOANS.ID.VARIOUS_CREDIT || this.loanId === LOANS.ID.DIVERSAL_ATENTION;
  }

  isVariousCredit() {
    return this.loanId === LOANS.ID.VARIOUS_CREDIT;
  }

  isDiversalAtention() {
    return this.loanId === LOANS.ID.DIVERSAL_ATENTION;
  }

  hasMinFeeSection() {
    return this.loanId === LOANS.ID.FIVE_MONTH || this.loanId === LOANS.ID.NINE_MONTH;
  }

  calcMinFee() {
    if (this.serviceClosed) {
      return;
    }

    const creditworthiness = this.creditworthiness;
    const loanCreditworthiness = creditworthiness[this.loanId];
    this.minimumFee = loanCreditworthiness.maximumLimit / this.loan.minMonthlyFeeDivider;
  }

  onNavigateSignUp() {
    if (this.serviceClosed) {
      return;
    }

    const loanId = this.loanId;
    const from = STATES.LOANS.DETAIL;
    const creditworthiness = this.creditworthiness;
    const creditworthinessOfLoan = creditworthiness[loanId];
    const hireDate = creditworthiness.hireDate;

    const hardReset = true;

    try {
      this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
      return this.state.go(STATES.LOANS.SIGN_UP, {loanId, from, hardReset});
    } catch (reason) {
      this.presentCannotSignUpModal(reason.message);
    }
  }

  presentCannotSignUpModal(reason) {
    this.cannotSignUpError = reason;
    this.modal.modal('show');
  }

  goMyLoans() {
    this.modal.modal('hide');
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  calcTypeInterest($event) {
    if (this.serviceClosed) {
      return;
    }

    this.coefficient = this.getCoefficient($event.amount);
    this.resultTypeInterest = (this.coefficient * this.euribor) * 0.01;
    this.resultTypeInterest = `${(Math.floor(this.resultTypeInterest * 1000) / 1000).toFixed(3)} %`;
    return this.resultTypeInterest;
  }

  getCoefficient(amount) {
    const theoricalCoefficient = ((120000 * 0.95) + ((amount - 120000) * 1.10)) / amount;
    const coefficient = amount < MIN_AMOUNT ? FIXED_COEFFICIENT : theoricalCoefficient;
    const formattedCoefficient = coefficient * 100;
    return formattedCoefficient;
  }

}

export default LoansDetailController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetail.controller.js